//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql

import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.Mutation
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import com.wintermar.inspection.graphql.adapter.ApproveInspectionMutation_ResponseAdapter
import com.wintermar.inspection.graphql.adapter.ApproveInspectionMutation_VariablesAdapter
import com.wintermar.inspection.graphql.selections.ApproveInspectionMutationSelections
import com.wintermar.inspection.graphql.type.ApproveInspectionCommandInput
import kotlin.Any
import kotlin.Boolean
import kotlin.String
import com.wintermar.inspection.graphql.type.Mutation as CompiledMutation

public data class ApproveInspectionMutation(
  public val approveInspectionCommandInput: ApproveInspectionCommandInput,
) : Mutation<ApproveInspectionMutation.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    ApproveInspectionMutation_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = ApproveInspectionMutation_ResponseAdapter.Data.obj()

  override fun rootField(): CompiledField = CompiledField.Builder(
    name = "data",
    type = CompiledMutation.type
  )
  .selections(selections = ApproveInspectionMutationSelections.__root)
  .build()

  @ApolloAdaptableWith(ApproveInspectionMutation_ResponseAdapter.Data::class)
  public data class Data(
    public val approveInspection: Any,
  ) : Mutation.Data

  public companion object {
    public const val OPERATION_ID: String =
        "ab5f25685d3e04707e69330035adc54b24cbb305e75efd5c7441cd05af8c39f8"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * mutation approveInspection($approveInspectionCommandInput: ApproveInspectionCommandInput!) {
     *   approveInspection(command: $approveInspectionCommandInput)
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "mutation approveInspection(${'$'}approveInspectionCommandInput: ApproveInspectionCommandInput!) { approveInspection(command: ${'$'}approveInspectionCommandInput) }"

    public const val OPERATION_NAME: String = "approveInspection"
  }
}
